import React from 'react';

const Facebook = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 25">
        <path
            fill="currentColor"
            fillRule="nonzero"
            d="M8.438 25V13.597h3.832l.575-4.444H8.439V6.315c0-1.287.357-2.163 2.204-2.163L13 4.15V.175A31.674 31.674 0 0 0 9.567 0C6.168 0 3.843 2.072 3.843 5.875v3.278H0v4.444h3.843V25h4.595Z"
        />
    </svg>
);

export default Facebook;
